import { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [permissions, setPermissions] = useState([]);

  const login = (token, user, userPermissions) => {
    localStorage.setItem("token", token);
    localStorage.setItem("me", JSON.stringify(user));
    localStorage.setItem("permissions", JSON.stringify(userPermissions));

    setPermissions(userPermissions);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("me");
    localStorage.removeItem("permissions");

    setPermissions([]);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, permissions, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return context;
};

export const getToken = () => {
  const token = localStorage.getItem("token");
  return token || null;
};

export const getMe = () => {
  const userDetails = localStorage.getItem("me");
  return userDetails ? JSON.parse(userDetails) : {};
};

export const getUserPartner = () => {
  const me = getMe();
  return me?.partner || null;
};

export const getPermissions = () => {
  try {
    const permissions = localStorage.getItem("permissions");

    if (!permissions || permissions === "undefined") {
      return [];
    }

    return JSON.parse(permissions);
  } catch (err) {
    console.error("Invalid permissions in localStorage", err);
    return [];
  }
};
